import { IEntity } from './IEntity';

export const resourceNameLogEntry = `logentry`;

export interface ILogEntry extends IEntity {
	entry: string;
	kips: number;
	goaldatapointid?: number;
	significance: number;
}

export const maxDatapointAgeForDaysLeft = 30;